import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, Gift, Heart } from 'lucide-react';
import API_ENDPOINTS from '../../config/api';
import { formatPledgeAmount } from '../../utils/formatPledgeAmount';

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.ADMIN_DASHBOARD);
      if (response.data.success) {
        setDashboardData(response.data.dashboard);
      }
    } catch (error) {
      console.error('Error fetching dashboard:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading dashboard...</div>;

  return (
    <div className="dashboard">
      <h1>Dashboard Overview</h1>
      <div className="stats-grid">
        <div className="stat-card">
          <Users size={40} />
          <h3>Total RSVPs</h3>
          <p className="stat-number">{dashboardData?.total_rsvps || 0}</p>
        </div>
        <div className="stat-card">
          <Gift size={40} />
          <h3>Gifts Reserved</h3>
          <p className="stat-number">{dashboardData?.total_gifts_reserved || 0}</p>
        </div>
        <div className="stat-card">
          <Heart size={40} />
          <h3>Cash Pledged</h3>
          <div className="stat-number-list" style={{ marginTop: '8px' }}>
            {dashboardData?.cash_pledged_by_currency && dashboardData.cash_pledged_by_currency.length > 0 ? (
              dashboardData.cash_pledged_by_currency.map(item => (
                <div key={item.currency} className="currency-total-item" style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                  {formatPledgeAmount(item.total, item.currency)}
                </div>
              ))
            ) : (
              <p className="stat-number" style={{ margin: 0 }}>
                {formatPledgeAmount(0, dashboardData?.pledge_currency || 'KES')}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="recent-rsvps">
        <h2>Recent RSVP Submissions</h2>
        <table className="data-table">
          <thead>
            <tr><th>Name</th><th>Email</th><th>Attendance</th><th>Date</th></tr>
          </thead>
          <tbody>
            {dashboardData?.recent_rsvps?.map(rsvp => (
              <tr key={rsvp.id}>
                <td>{rsvp.full_name}</td>
                <td>{rsvp.email}</td>
                <td>{rsvp.attendance_days}</td>
                <td>{new Date(rsvp.submitted_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;